import { render, staticRenderFns } from "./cooperation-report-detail.vue?vue&type=template&id=4a10fcea&scoped=true&"
import script from "./cooperation-report-detail.vue?vue&type=script&lang=js&"
export * from "./cooperation-report-detail.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-report-detail.vue?vue&type=style&index=0&id=4a10fcea&scoped=true&lang=scss&"
import style1 from "./cooperation-report-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a10fcea",
  null
  
)

export default component.exports